import { MainState } from "../MainState";
import { useMainContext } from "../MainBlocContext";
import { BlocBuilder } from "@kernel/frontend-react-app";
import { useEffect, useMemo } from "react";

export interface UseMainBloc extends MainState {
  title: string;
  version: string;
  versionTag: string;
  customer: string;
  footerEnabled: boolean;
  logo: string;
  logoMini: string;
  logoStats: string;
}

export function useMainBloc(): UseMainBloc {
  const bloc = useMainContext();
  const useBloc = BlocBuilder(bloc);
  const state = useBloc();

  const logo = useMemo(
    () => import.meta.env.BASE_URL + import.meta.env.VITE_APP_LOGO,
    []
  );
  const logoMini = useMemo(
    () => import.meta.env.BASE_URL + import.meta.env.VITE_APP_STEMMA,
    []
  );
  const logoStats = useMemo(
    () => import.meta.env.BASE_URL + import.meta.env.VITE_APP_LOGO_BLUE,
    []
  );
  const title = useMemo(() => import.meta.env.VITE_APP_NAME, []);
  const version = useMemo(() => import.meta.env.VITE_APP_VERSION, []);
  const versionTag = useMemo(() => import.meta.env.VITE_APP_VERSION_TAG, []);
  const customer = useMemo(() => import.meta.env.VITE_CUSTOMER, []);
  const footerEnabled = useMemo(
    () => import.meta.env.VITE_FOOTER_ENABLED == true,
    []
  );

  useEffect(() => {
    const bootstrap = async () => {
      await bloc.loadConfigs(["intl", "webrtc"]);
      bloc.finish();
    };
    bootstrap().catch((err) => console.error(err));
  }, []);

  return {
    ...state,
    title,
    version,
    versionTag,
    customer,
    footerEnabled,
    logo,
    logoMini,
    logoStats
  };
}
